import {publish} from 'utils/subscriber'
import PUB_SUB_EVENTS from '../utils/consts'

export default () => {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);

      const vm = this
      const addButton = document.querySelectorAll('[name="add"]');
      const careButton = document.querySelector('.client-care');
      this.buttonPrices = document.querySelectorAll('.button-price');
      const selectElem = document.querySelectorAll('.product-form__input--dropdown .select__select');
      let isEarring = false
      let hasOneVariant = false
      // eslint-disable-next-line
      let hasGoldColor = false;
      // eslint-disable-next-line
      let hasOneHiddenOption = true;
      this.preselectRequired = false;

      selectElem.forEach(item => {
        if (item.classList.contains('earrings-select')) {
          isEarring = true
        }

        if (selectElem.length === 1 && item.getAttribute('data-placeholder') === "Gold Color") {
          hasOneVariant = true
        }

        const placeholder = item.getAttribute('data-placeholder') || item.getAttribute('aria-label') || '';

        // Check if the select is "Gold Color"
        if (placeholder === 'Gold Color') {
          hasGoldColor = true;
        }

        // If a select has more than one option, it's not valid for preselection
        if (item.options.length === 1) {
          hasOneHiddenOption = true;
        }

        // If there's only one select other than Gold Color with more than one option
        if (selectElem.length > 2) {
          this.preselectRequired = true;
        }

      })


      if (addButton.length > 0 || careButton && selectElem.length > 0) {

        this.engravingSection = document.querySelector('.engraving-section');
        this.engraving();

        if (addButton.length > 0 && selectElem.length > 2 && !isEarring) {
          addButton.forEach(item => {
            // eslint-disable-next-line
            item.disabled = true;
            // eslint-disable-next-line
            item.querySelector('i').textContent = 'Make selection'
            // const buttonPrice = item.querySelector('.button-price');
            document.querySelector('.sticky-add-to-cart-link').classList.remove('hidden')
            document.querySelector('.sticky-form').classList.add('hidden')
            document.querySelector('.sticky-form').style.display = 'none'
          })
          // buttonPrices.forEach(buttonPrice => {
          //   // buttonPrice.classList.add('hidden')
          // })

        }

        if (hasOneVariant || selectElem.length === 2 || selectElem.length === 1) {
          document.querySelector('.sticky-add-to-cart-link').classList.add('hidden')
          document.querySelector('.sticky-form').classList.remove('hidden')
          document.querySelector('.sticky-form').style.display = 'inline-block'
        } else {
          document.querySelector('.sticky-add-to-cart-link').classList.remove('hidden')
          document.querySelector('.sticky-form').classList.add('hidden')
          document.querySelector('.sticky-form').style.display = 'none'
        }


        // If all selects have only one option, preselect them and enable the button
        if (this.preselectRequired) {
          selectElem.forEach(select => {
            const placeholder = select.getAttribute('data-placeholder') || 'Select';
              // const sizeDataAttribute = select.getAttribute('data-bracelet-size-text') || null;
              // const sectionId = select.getAttribute('data-section-id') || null;
              const customSelect = document.createElement('div');
              customSelect.className = 'product-form__variants-custom-select';

              const trigger = document.createElement('div');
              if (select.classList.contains('earrings-select')) {
                trigger.className = 'product-form__variants-custom-select-trigger earrings';
              } else {
                trigger.className = 'product-form__variants-custom-select-trigger';
              }

              trigger.innerHTML = `<span>${placeholder} </span><div class="product-form__variants-arrow"></div>`;


              const optionsList = document.createElement('div');
              optionsList.className = 'product-form__variants-custom-options';
              optionsList.style.display = 'none';

              if(select.options.length <= 1) {
                customSelect.className = 'hidden';
                const firstOption = select.options[0];
                // eslint-disable-next-line
                trigger.innerHTML = `<span>${placeholder} - ${firstOption.text} </span><div class="product-form__variants-arrow"></div>`;
                // eslint-disable-next-line
                select.value = firstOption.value;
              }
              Array.from(select.options).forEach(option => {
                const optionDiv = document.createElement('div');
                optionDiv.className = 'product-form__variants-custom-option flex justify-between';
                const checkmark = `<span class="checkmark">&#10003;</span>`;

                const optionText = option.text;
                // eslint-disable-next-line
                const parts = optionText.split(/[\+\_]/);

                // Construct the first span with the main text
                let content = `<span class="product-form__custom-option-text">${checkmark} ${parts[0].trim()}</span>`;

                const operator = optionText.includes('_') ? '-' : '+';

                if (parts.length > 1 && placeholder.trim().toLowerCase() !== 'letter' &&  placeholder.trim().toLowerCase() !== 'number') {
                  content += `<span class="product-form__custom-option-text text-text_gray">
                    ${operator}${parts.slice(1).join('+').trim()}</span>`;
                }


                optionDiv.innerHTML = content;
                optionDiv.dataset.value = option.value;
                optionsList.appendChild(optionDiv);

                optionDiv.addEventListener('click', () => {
                  // Update all options to remove checkmark
                  document.querySelectorAll('.product-form__variants-custom-option .checkmark').forEach(ck => {
                    // eslint-disable-next-line
                    ck.style.display = 'none';
                  });

                  // Show checkmark for the current option
                  optionDiv.querySelector('.checkmark').style.display = 'inline-block';
                  // eslint-disable-next-line
                  select.value = option.value;

                  // Check if option.text contains "+" and remove that portion
                  let displayText = option.text;
                  if (displayText.includes('+')) {
                    // Remove the "+" and everything after it (trim any whitespace)
                    displayText = displayText.split('+')[0].trim();
                  }

                  if (trigger.classList.contains('earrings')) {
                    trigger.querySelector('span').textContent = displayText;
                    this.updateQuantity(displayText);
                  } else {
                    trigger.querySelector('span').textContent = `${placeholder} - ${displayText}`;
                  }

                  optionsList.style.display = 'none'; // Close dropdown
                  const event = new Event('change', {bubbles: true});
                  select.dispatchEvent(event);
                  vm.onVariantChange(event, option.text);
                });
              });

              customSelect.appendChild(trigger);
              customSelect.appendChild(optionsList);
              select.insertAdjacentElement('afterend', customSelect);

              // trigger.addEventListener('click', (e) => {
              //   trigger.querySelector('.product-form__variants-arrow').classList.toggle('rotate-180')
              //   optionsList.style.display = optionsList.style.display === 'none' ? 'block' : 'none';
              //   select.dispatchEvent(new Event('change'));
              //   vm.onVariantChange(e);
              // });
              trigger.addEventListener('click', () => {
                trigger.querySelector('.product-form__variants-arrow').classList.toggle('rotate-180');
                optionsList.style.display = optionsList.style.display === 'none' ? 'block' : 'none';
              });


              // Add click listener to close the dropdown when clicking outside
              document.addEventListener('click', (event) => {
                if (!customSelect.contains(event.target)) {
                  optionsList.style.display = 'none';
                  trigger.querySelector('.product-form__variants-arrow').classList.remove('rotate-180');
                }
              });

          });
        } else {
          selectElem.forEach(select => {
              const placeholder = select.getAttribute('data-placeholder') || 'Select';
              const customSelect = document.createElement('div');
              customSelect.className = 'product-form__variants-custom-select';

              const trigger = document.createElement('div');
              if (select.classList.contains('earrings-select')) {
                trigger.className = 'product-form__variants-custom-select-trigger earrings';
              } else {
                trigger.className = 'product-form__variants-custom-select-trigger';
              }

              const optionsList = document.createElement('div');
              optionsList.className = 'product-form__variants-custom-options';
              optionsList.style.display = 'none';

              if(select.options.length <= 1) {
                customSelect.className = 'hidden';
              }

              // Preselect the first option
            const firstOption = select.options[0];
            // eslint-disable-next-line
            trigger.innerHTML = `<span>${placeholder} - ${firstOption.text} </span><div class="product-form__variants-arrow"></div>`;
            // eslint-disable-next-line
              select.value = firstOption.value;

            Array.from(select.options).forEach(option => {

                const optionDiv = document.createElement('div');
                optionDiv.className = 'product-form__variants-custom-option flex justify-between';
                const checkmark = `<span class="checkmark" style="display: none;">&#10003;</span>`;

              const optionText = option.text;
                // eslint-disable-next-line
              const parts = optionText.split(/[\+\_]/);

                let content = `<span class="product-form__custom-option-text">${checkmark} ${parts[0].trim()}</span>`;
                const operator = optionText.includes('_') ? '-' : '+';

                if (parts.length > 1 && placeholder.trim().toLowerCase() !== 'letter' &&  placeholder.trim().toLowerCase() !== 'number') {
                  content += `<span class="product-form__custom-option-text text-text_gray">
                    ${operator}${parts.slice(1).join('+').trim()}</span>`;
                }

                optionDiv.innerHTML = content;
                optionDiv.dataset.value = option.value;
                optionsList.appendChild(optionDiv);


                // trigger.addEventListener('click', (e) => {
                //   trigger.querySelector('.product-form__variants-arrow').classList.toggle('rotate-180');
                //   optionsList.style.display = optionsList.style.display === 'none' ? 'block' : 'none';
                //   select.dispatchEvent(new Event('change'));
                //   vm.onVariantChange(e);
                // });

                // trigger.addEventListener('click', () => {
                //   trigger.querySelector('.product-form__variants-arrow').classList.toggle('rotate-180');
                //   optionsList.style.display = optionsList.style.display === 'none' ? 'block' : 'none';
                // });

                // Highlight the preselected option
                if (option.value === firstOption.value) {
                  optionDiv.querySelector('.checkmark').style.display = 'inline-block';
                }

              optionDiv.addEventListener('click', () => {
                  // Remove checkmark from all options
                document.querySelectorAll('.product-form__variants-custom-option .checkmark').forEach(ck => {
                    // eslint-disable-next-line
                    ck.style.display = 'none';
                  });

                  // Show checkmark for the selected option
                optionDiv.querySelector('.checkmark').style.display = 'inline-block';
                  // eslint-disable-next-line
                  select.value = option.value;

                  let displayText = option.text;
                  if (displayText.includes('+')) {
                    displayText = displayText.split('+')[0].trim();
                  }

                  if (trigger.classList.contains('earrings')) {
                    trigger.querySelector('span').textContent = `${displayText}`;
                    this.updateQuantity(option.text);
                  } else {
                    trigger.querySelector('span').textContent = `${placeholder} - ${displayText}`;
                  }

                  optionsList.style.display = 'none'; // Close dropdown
                  const event = new Event('change', { bubbles: true });
                  select.dispatchEvent(event);
                  vm.onVariantChange(event, option.text);
                });
              });

              customSelect.appendChild(trigger);
              customSelect.appendChild(optionsList);
              select.insertAdjacentElement('afterend', customSelect);

              trigger.addEventListener('click', () => {
                trigger.querySelector('.product-form__variants-arrow').classList.toggle('rotate-180');
                optionsList.style.display = optionsList.style.display === 'none' ? 'block' : 'none';
              });

              document.addEventListener('click', (event) => {
                if (!customSelect.contains(event.target)) {
                  optionsList.style.display = 'none';
                  trigger.querySelector('.product-form__variants-arrow').classList.remove('rotate-180');
                }
              });

              // Trigger the initial 'change' event for the preselected option
              const initEvent = new Event('change', { bubbles: true });
              select.dispatchEvent(initEvent);
          });
        }
      }
    }

    updateQuantity(optionText) {
      // eslint-disable-next-line
      let input;
      this.buttonPrices.forEach(buttonPrice => {
        input = buttonPrice.innerHTML;
      });

      const regex = /[\d,]+\.\d+/;
      const match = input.match(regex);
      const formList = document.querySelectorAll('form[data-type="add-to-cart-form"]');

      let quantityInput;
      formList.forEach(form => {
        quantityInput = form.querySelector('input[name="quantity"]');

        if (!quantityInput) {
          quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.name = 'quantity';
          form.appendChild(quantityInput);
        }

        if (optionText.toLowerCase() === 'pair') {
          if (match) {
            const numberString = match[0];
            const number = parseFloat(numberString.replace(/,/g, ''));
            this.buttonPrices.forEach(buttonPrice => {
              // eslint-disable-next-line
              buttonPrice.innerHTML = `•  ${this.formatMoney(
                {amount: number * 2, currencyCode: Shopify.currency.active},
                true
              )}`;
            });
          }
          quantityInput.value = '2';
        } else {
          quantityInput.value = '1';
        }
      })

    }

    validateInputs() {
      const inputs = this.engravingSection.querySelectorAll('.engraving-block.active input');
      const spans = document.querySelectorAll('variant-selects .product-form__input:not(.not-check) .product-form__variants-custom-select-trigger span');

      const updateButtonState = () => {
        const inputsValue = Array.from(inputs).some(input => input.value !== "");
        const hasHyphen = Array.from(spans).every(span => span.textContent.includes('-'));

        if (inputsValue && hasHyphen) {
          this.toggleAddButton(false, '', false);
        } else {
          this.toggleAddButton(true, 'Make selection', false);
        }
      };

      if (inputs.length > 0) {
        inputs.forEach(input => {
          const pattern = input.getAttribute('pattern');
          if (pattern) {
            const regex = new RegExp(pattern);
            input.addEventListener('input', (event) => {
              // eslint-disable-next-line
              const value = event.target.value;
              // eslint-disable-next-line
              if (!regex.test(value)) {
                // eslint-disable-next-line
                event.target.value = value.slice(0, -1);
              }
              updateButtonState();
            });
          }
        });

        updateButtonState();
      }
    }

    engraving() {
      if (this.engravingSection) {
        const engravingBlocks = this.engravingSection.querySelectorAll('.engraving-block');
        const hasVariantId = Array.from(engravingBlocks).some(block => block.hasAttribute('variantId'));

        if (hasVariantId && this.currentVariant) {
          // eslint-disable-next-line
          this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => this.options[index] === option).includes(false);
          });
          const curVariant = this.currentVariant.id - 0;

          engravingBlocks.forEach(block => {
            // eslint-disable-next-line
            if (block.getAttribute('variantId') == curVariant) {
              block.classList.add('active');
            } else {
              block.classList.remove('active');
            }
          });

          setTimeout(() => {
            this.validateInputs();
          }, 800)
        } else {
          setTimeout(() => {
            this.validateInputs();
          }, 800)
        }
      }
    }

    validateSelection() {
      const selectElements = Array.from(this.querySelectorAll('select'));
      return selectElements.every(select => select.value && select.value !== "" && select.selectedIndex > 0);
    }

    onVariantChange(event, val) {
      this.updateOptions();

      const isValidSelection = this.validateSelection();

      // Toggle button state based on selection validity
      this.toggleAddButton(!isValidSelection, '', false);

      this.updateMasterId();
      this.updateSelectedSwatchValue(event);
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updateVariantStatuses();

      this.engraving();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo(val);
      }
    }

    updateOptions() {
      // eslint-disable-next-line
      this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
        if (element.tagName === 'SELECT') {
          return element.value;
        }
      });
    }

    updateMasterId() {
      // eslint-disable-next-line
      this.currentVariant = this.getVariantData().find((variant) => {
        // eslint-disable-next-line
        return !variant.options
          // eslint-disable-next-line
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateSelectedSwatchValue({target}) {
      const {name, tagName} = target;

      if (tagName === 'SELECT' && target.selectedOptions.length) {
        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
        if (!selectedDropdownSwatchValue) return;
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
          selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
        } else {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
          selectedDropdownSwatchValue.classList.add('swatch--unavailable');
        }
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.sectionId}, #product-form-installment-${this.dataset.sectionId}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }

    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(':checked').value === variant.option1
      );
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('option')];
        // const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available)
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setInputAvailability(elementList, availableValuesList) {
      elementList.forEach((element) => {
        const value = element.getAttribute('value');
        const availableElement = availableValuesList.includes(value);
        // eslint-disable-next-line
        if (element.tagName === 'OPTION') {
          // eslint-disable-next-line
          element.innerText = availableElement
            ? value
            : window.variantStrings.unavailable_with_option.replace('[value]', value);
        }
      });
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    formatMoney({amount, currencyCode = 'USD'}, cents = false) {
      let amt = amount;
      if (Number.isNaN(amt))
        // eslint-disable-next-line no-console
        return console.error('utils/format-money.js: No amount value passed.');

      if (cents) amt /= 100;

      const isWholeNumber = amt % 1 === 0;

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: isWholeNumber ? 0 : 2,
        maximumFractionDigits: 2,
      });

      return formatter.format(amt);
    };

    renderProductInfo(val) {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.sectionId;

      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          // change price in button
          const buttonsPrice = document.querySelectorAll('.button-price');

          if (val && val.toLowerCase() === 'pair') {
            buttonsPrice.forEach(buttonPrice => {
              // eslint-disable-next-line
              buttonPrice.textContent = `•  ${this.formatMoney({
                amount: this.currentVariant.price * 2,
                currencyCode: Shopify.currency.active
              }, true)}`;
            })
          } else {
            buttonsPrice.forEach(buttonPrice => {
              // eslint-disable-next-line
              buttonPrice.textContent = `•  ${this.formatMoney({
                amount: this.currentVariant.price,
                currencyCode: Shopify.currency.active
              }, true)}`;
            })
          }

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = document.getElementById(`price-${this.dataset.sectionId}`);
          const source = html.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.sectionId}`
          );

          const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.sectionId}`);
          const pricePerItemSource = html.getElementById(
            `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.sectionId}`
          );

          if (source && destination) destination.innerHTML = source.innerHTML;

          if (pricePerItemSource && pricePerItemDestination) {
            pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
            pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
          }

          const price = document.getElementById(`price-${this.dataset.sectionId}`);

          if (price) price.classList.remove('hidden');

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          });
        });
    }

    // eslint-disable-next-line
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForms = document.querySelectorAll(`.product-form-${this.dataset.sectionId}`);

      if (!productForms) return;
      productForms.forEach(productForm => {
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > i');
        const buttonPrice = productForm.querySelector('.button-price');


        const spans = document.querySelectorAll('variant-selects .product-form__input:not(.not-check) .product-form__variants-custom-select-trigger span');

        const validVariants = Array.from(spans).every(span => {
          // eslint-disable-next-line
          const text = span.textContent.trim().toLowerCase();
          return text.includes('-') || text === 'single' || text === 'pair';
        });


        if (!addButton) return;
        // eslint-disable-next-line
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          // buttonPrice.classList.add('hidden')
          document.querySelector('.sticky-add-to-cart-link').classList.remove('hidden')
          document.querySelector('.sticky-form').classList.add('hidden')
          document.querySelector('.sticky-form').style.display = 'none'
          if (text) {
            addButtonText.textContent = text
            buttonPrice.classList.remove('hidden')
          }
        } else {
          // eslint-disable-next-line
          if (validVariants) {
            addButton.removeAttribute('disabled');
            document.querySelector('.sticky-add-to-cart-link').classList.add('hidden')
            document.querySelector('.sticky-form').classList.remove('hidden')
            document.querySelector('.sticky-form').style.display = 'inline-block'
            // document.querySelector('.sticky-block-btn').classList.remove('hidden')
            addButtonText.textContent = window.variantStrings.addToCart;
            buttonPrice.classList.remove('hidden')
          }

        }
        // eslint-disable-next-line
        if (!modifyClass) return;
      })

    }

    setUnavailable() {
      const buttons = document.querySelectorAll(`.product-form-${this.dataset.sectionId}`);
      buttons.forEach(button => {
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > i');
        const price = document.getElementById(`price-${this.dataset.sectionId}`);
        const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.sectionId}`);


        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (pricePerItem) pricePerItem.classList.add('hidden');
      })

    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  const init = () => {
    if (!customElements.get("variant-selects")) {
      customElements.define('variant-selects', VariantSelects);
    }
  };
  init();
};
